import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import { createReduxHistoryContext } from 'redux-first-history';
import { AppReducer } from "../reducers/appReducer";

export default function configureStore (history, initialState) {
  const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({ 
    history 
  });

  const reducers = {
    "app": AppReducer
  };

  const middleware = [
    thunk,
    routerMiddleware
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }

  const rootReducer = combineReducers({
    ...reducers,
    router: routerReducer
  });

  const store = createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );

  // Create redux history
  store.reduxHistory = createReduxHistory(store);

  return store;
}
